<template>
  <div>
    <div
      class="px-4 sm:px-6 md:px-8 mb-8 flex items-center justify-between flex-wrap sm:flex-no-wrap"
    >
      <div class="max-w-7xl">
        <h1 class="text-2xl font-semibold text-gray-900">Team</h1>
      </div>
      <div class="flex-shrink-0">
        <span class="inline-flex rounded-md shadow-sm">
          <button
            @click="openModal"
            type="button"
            class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
          >
            Ajouter un nouveau membre
          </button>
        </span>
      </div>
    </div>

    <div class="px-4 sm:px-6 md:px-8 mt-4">
      <div class="flex flex-col">
        <div
          class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        >
          <div
            class="bg-white shadow overflow-hidden sm:rounded-md"
            v-if="hasUsers"
          >
            <ul>
              <user-row
                v-for="teamUser in users"
                :key="teamUser.id"
                :user="teamUser"
              ></user-row>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <add-user-modal :open="open" @close="closeModal"></add-user-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UserRow from "@/components/Team/UserRow";
import AddUserModal from "@/components/Team/AddUserModal";
export default {
    components: {
        UserRow,
        AddUserModal
    },
    data() {
        return {
            open: false
        };
    },
    computed: {
        ...mapState("team", ["users"]),
        hasUsers() {
            return this.users.length > 0;
        }
    },
    methods: {
        openModal() {
            this.open = true;
        },
        closeModal() {
            this.open = false;
        }
    }
};
</script>